import React from 'react';
// page import
import Hero from './Hero';
import Section from '../schoolcollege/Index';
import SchoolCollege from '../schoolcollege/SchoolCollege';
import Homeadsslider from '../Homeadsslider';
import Population from './population/Index';
import HomeSliderBanner from '../HomeSliderBanner';
import AboutApp from '../app/AboutApp';
import Event from '../event/Event';
import Bloge from '../blog/Bloge';
import Header from '../../layout/Header';
import Footer from '../../layout/Footer';



const Index = () => {
    return (
        <>
        <Header />
            <Hero />
            <Section />
            <SchoolCollege />
            <Homeadsslider />
            <Population />
            <AboutApp />
            <Event />
            <HomeSliderBanner />
            <Bloge />
<Footer />

        </>
    );
};

export default Index;
